<div class="pc-page-shell">
  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">

      <div class="filter-header">
        <div class="filter-header__title">
          <mat-icon aria-hidden="true">filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>
        <mat-icon class="close-btn" (click)="closeFilterDrawer()">close</mat-icon>
      </div>

      <!-- Body -->
      <form [formGroup]="filterForm" class="filter-body">

        <!-- Date Range -->
        <div class="filter-section">
          <h4>Date Range</h4>

          <app-custom-date-picker [label]="'From Date'" [controlname]="filterForm.controls['from_date']">
          </app-custom-date-picker>

          <app-custom-date-picker [label]="'To Date'" [controlname]="filterForm.controls['to_date']">
          </app-custom-date-picker>
        </div>

        <!-- Client -->
        <div class="filter-section" *ngIf="isMerakiOperations()">
          <h4>Client</h4>
          <app-pc-multi-select-filter
            label=""
            placeholder="Select Client"
            allLabel="All"
            [options]="clientOptions"
            [lightMode]="!isDarkMode()"
            [(selected)]="selectedClients">
          </app-pc-multi-select-filter>
        </div>

        <!-- Segment -->
        <div class="filter-section">
          <h4>Segment</h4>
          <app-pc-multi-select-filter
            label=""
            placeholder="Select Segment"
            allLabel="All"
            [options]="segmentOptions"
            [lightMode]="!isDarkMode()"
            [(selected)]="selectedSegments">
          </app-pc-multi-select-filter>
        </div>

        <!-- Ship Details -->
        <div class="filter-section">
          <h4>Ship Details</h4>

          <input
            type="text"
            class="form-control"
            id="shipName"
            formControlName="shipName"
            placeholder="Ship Name"
            (input)="filterShipNames($event)"
            [matAutocomplete]="autoShip" />

          <mat-autocomplete #autoShip="matAutocomplete">
            <mat-option *ngFor="let ship of shipNameSuggestions" [value]="ship.shipName">
              {{ ship.shipName }}
            </mat-option>
          </mat-autocomplete>

          <app-custom-input
            placeholder="I.M.O Number"
            label=""
            [controlname]="filterForm.controls['imoNumber']">
          </app-custom-input>
        </div>

      </form>

      <div class="filter-footer">
        <button type="button" class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear Filter
        </button>

        <button type="button" class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply Filter
        </button>
      </div>

    </div>
  </div>
  <div class="filter-overlay" *ngIf="isFilterOpen" (click)="closeFilterDrawer()"></div>

  <div class="container pc-performance-page">
    <header class="pc-page-header">
      <p class="title pc-page-header__title">
        Port Performance <mat-icon class="titleIcon">chevron_right</mat-icon> Technical
        Performance
        <mat-icon class="titleIcon">chevron_right</mat-icon>
      </p>
      <div class="pc-page-header__actions">
        <app-back-button (back)="goBack()"></app-back-button>
        <button
          type="button"
          class="pc-page-header__filter-btn"
          (click)="isFilterOpen = true"
          matTooltip="Table Filter"
          aria-label="Open table filters"
        >
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>
    </header>

    <div class="pc-performance-table-stack">
  <div class="table-view-banner view-active">
    <mat-icon>table_chart</mat-icon>
    <div class="banner-copy">
      <span class="banner-title">Technical Performance</span>
    </div>
    <span class="banner-count">{{ length || 0 }} records</span>
  </div>
  <div class="detail-rail-table-wrapper pc-performance-table-wrapper">
  <div
    class="detail-rail-table-scroll table-container scroll-bar pc-performance-table-scroll pc-data-table"
    [class.pc-data-table--dark]="isDarkMode()"
  >
    <table
      class="pc-performance-table mat-elevation-z8 printable-table"
      #table
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="sticky-header">
        <tr class="pc-group-header-row">
          <th rowspan="2" class="th-text-center2 centersno">Sr No</th>
          <th class="th-text-center printView" rowspan="2">Vessel View</th>
          <th rowspan="2" class="th-text-center3">Vessel Name</th>
          <th rowspan="2" class="th-text-center2">IMO No</th>
          <th rowspan="2" class="th-text-center" *ngIf="isMerakiOperations()">
            Client
          </th>
          <th rowspan="2" class="th-text-center">Segment</th>
          <!-- <th rowspan="2" class="th-text-center">Port</th>
          <th rowspan="2" class="th-text-center">Operation</th> -->

          <!-- Actual -->
          <th colspan="3" class="th-text-center th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Actual (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Actual Consumption (MT)">info</mat-icon>
            </span>
          </th>

          <!-- Technical Baseline -->
          <th colspan="3" class="th-text-center th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Tech Baseline (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Technical Baseline Consumption (MT)">info</mat-icon>
            </span>
          </th>

          <th rowspan="2" class="th-text-center th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Tech Gain/Loss (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Loss or Gain as per Technical Baseline (MT)">info</mat-icon>
            </span>
          </th>
        </tr>

        <tr class="pc-sub-header-row">
          <!-- Actual -->
          <th class="th-text-center2 th-fuel">HSFO</th>
          <th class="th-text-center2 th-fuel">VLSFO</th>
          <th class="th-text-center2 th-fuel">MGO</th>

          <!-- Baseline -->
          <th class="th-text-center2 th-fuel">HSFO</th>
          <th class="th-text-center2 th-fuel">VLSFO</th>
          <th class="th-text-center2 th-fuel">MGO</th>
        </tr>
      </thead>
      <tbody *ngIf="isLoadingTable">
  <tr *ngFor="let dummy of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="skeleton-row">
    <td class="centersno"><div class="skeleton-bar sno-skeleton"></div></td>
    <td><div class="skeleton-bar icon-skeleton"></div></td>
    <td class="fixed-col"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td *ngIf="isMerakiOperations()"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Actual Consumption Columns -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Tech Baseline Columns -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Tech Gain/Loss -->
    <td><div class="skeleton-bar"></div></td>
  </tr>
</tbody>
      <tbody *ngIf="!isLoadingTable">
        <tr *ngFor="let element of paginatedData; let i = index">

          <td class="centersno">{{ getRowSerialNumber(i) }}</td>

          <!-- Eye Button -->
          <td>
            <button class="gradient-btn" (click)="showDetails(element)" [ngStyle]="{
                'background-image': 'linear-gradient(98deg, #0046de, #006063)',
                'border-radius': '11px',
                border: 'none'
              }">
              <mat-icon fontSet="material-icons-outlined" fontIcon="visibility"
                class="visiblityIcon">visibility_outlined</mat-icon>
            </button>
          </td>

          <td class="fixed-col">{{ element.vesselName }}</td>
          <td>{{ element.imoNumber }}</td>
          <td *ngIf="isMerakiOperations()">
            {{ element.client }}
          </td>

          <td>
            <span [ngStyle]="getDynamicSegmentStyle(element.segment)">
              {{ element.segment }}
            </span>
          </td>

          <!-- <td>{{ element.port || '__' }}</td>
          <td>{{ element.operation || '__' }}</td> -->

          <!-- Actual -->
          <!-- Actual -->
          <td>{{ element.actualConsumption?.HSFO == 0 ? '-' : element.actualConsumption?.HSFO }}</td>
          <td>{{ element.actualConsumption?.VLSFO }}</td>
          <td>{{ element.actualConsumption?.MGO }}</td>

          <!-- Baseline -->
          <td>{{ element.baselineConsumption?.HSFO == 0 ? '-' : element.baselineConsumption?.HSFO }}</td>
          <td>{{ element.baselineConsumption?.VLSFO }}</td>
          <td>{{ element.baselineConsumption?.MGO }}</td>

          <!-- Loss or Gain -->
          <td [ngStyle]="getLossGainStyle(element.totalGainLoss)">
            {{ formatLossGainValue(element.totalGainLoss) }}
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  </div>
  <mat-paginator
    class="pc-performance-paginator"
    [length]="length"
    [pageSizeOptions]="[15, 25, 50, 100]"
    [pageIndex]="pageIndex"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  </div>
  <br />
  <!-- <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Download
    </button>
    <button class="btn btn-light hover-button mail" (click)="printTable()">
      <mat-icon>print</mat-icon>&nbsp; Print
    </button>
    <button class="btn btn-light hover-button mail" (click)="exportClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div> -->
  <br />
</div>
</div>